// extracted by mini-css-extract-plugin
export default {"sectionNav":"settings-nav_sectionNav__3jmir","sectionNavItem":"settings-nav_sectionNavItem__efRLC","active":"settings-nav_active__IasoI"};